import React, { useState, useEffect, useContext } from 'react'
import { FormattedMessage } from 'react-intl';
import API from '../../utils/API'
import { connect } from 'react-redux'
import './Navbar.css'
import { setUserState } from '../../store/user'
import InputValidation from '../../utils/InputValidation'
import EditUserModal from './NavbarAccountModal'
import ChangePasswordModal from './ChangePasswordModal'
import ScreenbeamLogo from '../../assets/icons/ScreenBeamCloudLogo.png'
import LocaleContext from '../../utils/LocaleContext';
import commonFunctions from '../../utils/commonFunctions';
import Toast from '../Toast/Toast';

function Navbar(props) {
  const [email, setEmail] = useState('');
  const { user } = props;

  const { locale, changeLocale } = useContext(LocaleContext);
  const { closeModal } = commonFunctions;

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  // User Modal State
  const [submitted, setSubmitted] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [sentEmail, setSentEmail] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [newPhone, setNewPhone] = useState('');
  
  // Validation states
  const [newEmailValid, setNewEmailValid] = useState('');
  const [newPhoneValid, setNewPhoneValid] = useState('');

  const validateNewEmail = (value) => {
    setNewEmailValid(InputValidation.validateUserEmail(value));
  };
  const validateNewPhone = (value) => {
    setNewPhoneValid(InputValidation.validatePhone(value, "phone"));
  };

  useEffect(() => {
    setEmail(user.email);
    setPhone(user.phone);
    setFirstName(user.firstName);
    setLastName(user.lastName);
  }, [user]);

  useEffect(() => {
    if (user) {
      API.updateUserPreferences(user.preferences);
    }
  }, [user.preferences]);

  useEffect(() => {
    // Perform field validations
    validateNewPhone(newPhone);
    validateNewEmail(newEmail);
  }, [newEmail, newPhone]);

  const handleLanguageChange = (newLocale) => {
    console.log("changing locale to", newLocale)
    changeLocale(newLocale);
  };

  function handleLogOut(e = null) {
    console.log('logout?')
    if (e)
      e.preventDefault()
    API.logout()
      .then(res => {
        const { data } = res

        if (data.error) return setError(data.error);
        
        setSuccess(<FormattedMessage id="LOG_OUT_SUCCESS" />);

        // Clear user state
        props.dispatch(setUserState(''));

        // Remove the token cookie by setting it to an expired date
        document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

        // Redirect to login page
        window.location = '/login';
      }).catch(err => {
        console.error(err)
        setError(err);
      })
  }

  /**
   * Clean up the user session and redirect to login page
   */
  function handleCleanUp() {
    // Clean up the user state
    props.dispatch(setUserState(''));
  
    // Remove the token cookie by setting it to an expired date
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  
    // Redirect to login page
    window.location = '/login';
  }

  const [prevUser, setPrevUser] = useState(props.user);

  useEffect(() => {
    // Function to check if the user prop has changed
    // console.log('polling navbar')
    const checkUserChange = () => {
      if (props.user !== prevUser) {
        // Update the prevUser state to the current user prop value
        setPrevUser(props.user);
      }
    };

    // Start polling every 3 seconds
    const intervalId = setInterval(checkUserChange, 3000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [props.user, prevUser]);

  /**
   * Opens check email modal
   */
  function openModal() {
    document.getElementById("backdrop").style.display = "block"
    document.getElementById("checkEmailModal").style.display = "block"
    document.getElementById("checkEmailModal").classList.add("show")
  }

  function handleEditAccount(e) {
    e.preventDefault()
    setNewEmail(email);
    setNewPhone(phone);
  }

  // Take info and update account owner info
  function handleDone() {
    console.log('done')
    setSubmitted(true);
    if (
      !newPhoneValid &&
      !newEmailValid
    ) {
      API.editUser({
        email: newEmail.trim(),
        phone: newPhone.trim(),
        firstName: firstName,
        lastName: lastName,
        id: user.id
      }).then(res => {
        const { data } = res
        if (data.error) return setError(data.error)
        props.dispatch(setUserState({ email: newEmail.trim(), phone: newPhone.trim(), firstName, lastName, }))
        // setEmail(newEmail);
        setPhone(newPhone.trim());
        closeModal('navbarUserModal');
        setSuccess(<FormattedMessage id="EDIT_USER_SUCCESS" />)
        if (newEmail.trim() !== email.trim()) {
          handleLogOut();
        }
      }).catch(err => {
        console.error(err)
        setError(err.message)
      })
    }
  }

  const userModalProps = {
    submitted, 
    firstName, setFirstName,
    lastName, setLastName,
    newEmail, setNewEmail, newEmailValid, 
    newPhone, setNewPhone, newPhoneValid, 
    handleDone,
    error, setError, 
  }

  const passwordModalProps = {
    error,
    handleCleanUp
  }

  return (
    <>
      <nav className='navbar'>
        <div className='btn-group me-auto'>
          <button className='hamburger-menu' onClick={props.toggleMobileMenu} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <img src={ScreenbeamLogo} alt="ScreenBeam Logo" className="navbar-logo" id="navbarLogo" />
        </div>
        <div className='btn-group dropdown'>
          <button className='language-btn dropdown-toggle' type='button' data-bs-toggle='dropdown' aria-expanded='false'>
            <span className='language language-full'>{locale === 'en' ? 'English' : '中文'}</span>
            <span className='language language-short'>{locale === 'en' ? 'EN' : 'CN'}</span>
          </button>
          <div className='dropdown-menu dropdown-menu-end' id="languageDropdown" aria-labelledby='languageDropdown'>
            <span className='dropdown-item' onClick={() => handleLanguageChange('en')}><FormattedMessage id="ENGLISH" /></span>
            <span className='dropdown-item' onClick={() => handleLanguageChange('zh')}><FormattedMessage id="CHINESE" /></span>
          </div>
        </div>
        <div className='btn-group dropdown'>
          <button className='user-btn dropdown-toggle' id="userBtn" type='button' data-bs-toggle='dropdown' aria-expanded='false'>
            <span className='username'>{email}</span>
          </button>
          <div className='dropdown-menu dropdown-menu-end' id="usernameDropdown" aria-labelledby='usernameDropdown' data-bs-placement="bottom-end">
            <span className='dropdown-item' id="editAccountBtn" type="button" data-bs-toggle="modal" data-bs-target="#navbarUserModal" onClick={handleEditAccount}><FormattedMessage id="EDIT_ACCOUNT_INFO" /></span>
            <span className='dropdown-item' id="changePasswordBtn" type="button" data-bs-toggle="modal" data-bs-target="#changePasswordModal"><FormattedMessage id="CHANGE_PASSWORD" /></span>
            <span className='dropdown-item logout' id="logoutBtn" onClick={handleLogOut}><FormattedMessage id="LOG_OUT" /></span>
          </div>
        </div>
      </nav>
      <EditUserModal {...userModalProps} />
      <ChangePasswordModal {...passwordModalProps}/>
      <Toast
        success={success}
        error={error}
        setSuccess={setSuccess}
        setError={setError}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(Navbar)
